import { render, staticRenderFns } from "./NewReturnPartners.vue?vue&type=template&id=2dabf25e&scoped=true&"
import script from "./NewReturnPartners.vue?vue&type=script&lang=js&"
export * from "./NewReturnPartners.vue?vue&type=script&lang=js&"
import style0 from "./NewReturnPartners.vue?vue&type=style&index=0&id=2dabf25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabf25e",
  null
  
)

component.options.__file = "NewReturnPartners.vue"
export default component.exports